import { render, staticRenderFns } from "./FicoPage.vue?vue&type=template&id=06e4f7c6&"
import script from "./FicoPage.vue?vue&type=script&lang=js&"
export * from "./FicoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports